import { Immutable } from "immer";
import React, { type JSX } from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import { interpolate } from "@thelabnyc/thelabui/src/utils/i18n";

import iconXClose from "../../../img/icons/x-close.svg";
import { IAPR, IMonths } from "../../models/nominals";
import {
    IServiceFooterValueProp,
    IServiceFooterValueProps,
} from "../../models/value-props";
import { formatAPR, formatTermLength } from "../../utils/format";
import { Link } from "../Link";

import styles from "./index.module.scss";

type IProps = Immutable<{
    apr: IAPR;
    length: IMonths;
    content: IServiceFooterValueProps;
}> & {
    onCloseModal: (
        event: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
    ) => void;
};

const ServiceFooterModalValueProp = (
    props: IServiceFooterValueProp & { apr: IAPR; length: IMonths },
) => {
    const title = interpolate(props.title, {
        apr: formatAPR(props.apr),
        length: formatTermLength(props.length),
    });

    let learnMoreLink: JSX.Element | null = null;
    if (props.learn_more_link) {
        learnMoreLink = (
            <Link className={styles.listLink} href={props.learn_more_link.url}>
                {t`Learn More`}
            </Link>
        );
    }

    return (
        <li className={styles.listItem}>
            <div>
                <img src={props.icon.url} loading="lazy" decoding="async" />
            </div>
            <div>
                <h5 dangerouslySetInnerHTML={{ __html: title }}></h5>
                <p dangerouslySetInnerHTML={{ __html: props.description }}></p>
                {learnMoreLink}
            </div>
        </li>
    );
};

export const ServiceFooterValuePropsModalContent = (
    props: IProps,
): React.ReactNode => {
    const valuePropElems = props.content.value_props.map((valueProp, i) => {
        return (
            <ServiceFooterModalValueProp
                key={i}
                apr={props.apr}
                length={props.length}
                {...valueProp}
            />
        );
    });

    return (
        <div>
            <button
                className={`${styles.close} service-footer-modal__close`}
                onClick={props.onCloseModal}
                aria-label={t`close`}
            >
                <SVG
                    aria-hidden={true}
                    className={styles.closeIcon}
                    src={iconXClose}
                    title={t`Close Icon`}
                />
            </button>
            <div
                className={`${styles.title} service-footer-modal-props__title`}
            >
                <span
                    dangerouslySetInnerHTML={{
                        __html: props.content.title,
                    }}
                ></span>
                <div className="service-footer-modal-props__title-bar"></div>
            </div>
            <ul className={styles.list}>{valuePropElems}</ul>
        </div>
    );
};
